import { Component, Inject, TemplateRef } from '@angular/core';
import { DialogService, DialogRef, DialogConfig, DIALOG_DATA } from '../dialog';
import { InputType } from 'src/app/components/input/input.types';

export interface SimpleDialogData {
  title: string;
  titleStyle?: { [key: string]: string | number };
  content?: string;
  contentStyle?: { [key: string]: string | number };
  noButton?: string;
  yesButton?: string;
  color?: 'primary' | 'accent';
  templateContent?: TemplateRef<any>;
  inputs?: {
    label: string;
    type: InputType;
    required?: boolean;
    value?: any;
  }[];
}

export interface SimpleDialogResult {
  action: boolean;
  message?: string[];
}

@Component({
  selector: 'app-simple-dialog',
  templateUrl: './simple-dialog.component.html',
  styleUrls: ['./simple-dialog.component.scss'],
})
export class SimpleDialogComponent {
  inputValues = [];

  public static open(
    dialog: DialogService,
    data: SimpleDialogData,
    config?: DialogConfig
  ): DialogRef<SimpleDialogComponent, SimpleDialogResult> {
    const c: DialogConfig = config || {};
    c.panelClass = 'simple-dialog';
    c.maxWidth = 'calc(100vw - 32px)';
    c.maxHeight = 'calc(100vh - 32px)';
    c.data = data;
    return dialog.open(SimpleDialogComponent, c);
  }

  constructor(
    public dialogRef: DialogRef<SimpleDialogComponent, SimpleDialogResult>,
    @Inject(DIALOG_DATA) public data: SimpleDialogData
  ) {
    if (this.data.inputs?.length > 1) {
      this.data.inputs.forEach((input) => {
        this.inputValues = this.inputValues.concat([input.value || '']);
      });
    }
  }

  get missingRequired(): boolean {
    return this.data.inputs?.some(
      (input, i) => input.required && !this.inputValues[i].length
    );
  }

  onOkClick() {
    this.dialogRef.close({ action: true, message: this.inputValues });
  }

  onNoClicked() {
    this.dialogRef.close(null);
  }
}
